import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import * as Setting from '../../utils/AuthUtils'
import Tournament from './Tournament';
import { api, wsBaseHref } from '../../AppConfig';

function RoutedTournament(props) {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  const { hasRights } = props;
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const tournamentQuery = useQuery({ 
    queryKey: [`tournament${id}`], 
    queryFn: () => 
      fetch(api.tournaments().detailsById(id).href).then((res) =>
        res.json(), 
      )
  })
  const participantsQuery = useQuery({ 
    queryKey: [`participants${id}`], 
    queryFn: () => 
      fetch(api.tournaments().players(id).href).then((res) =>
        res.json(), 
      )
  })

  const multipliersQuery = useQuery({ 
    queryKey: [`multipliers`], 
    queryFn: () => 
      fetch(wsBaseHref+"/tournaments/multipliers").then((res) =>
        res.json(), 
      )
  })

  const lpiseasonsQuery = useQuery({
    queryKey: ['lpiseasons'],
    queryFn: () => 
      fetch(wsBaseHref+"/lpiseasons").then((res) =>
        res.json(), 
      )
  })

  //otherwise we fetch the data and pass to the display component
  const byesQuery = useQuery({ 
    queryKey: ['byes'], 
    queryFn: () => 
      fetch(api.byes().list().href).then((res) =>
        res.json(), 
      )
  })

  const addPlayerQuery = useMutation({
    mutationFn: async (p) => {
      console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      let response = await fetch(api.tournaments().addPlayer(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p),
      })
      .catch((error) => {
        console.log(error);
        throw new Error('An error occurred');
      })
      if (response.status === 403) throw new Error('Forbidden!');
    },
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Successfully added player to event!');
      window.location.reload(false)
    },
    onError: () => {
      // console.warn('data arrivati dopo onError:', data, error, variables,context)
      message.error('Operation failed! Probably you do not have permission to do this.');
    },
    onSettled: (data, error) => {
      if (error === null) {
        console.warn('non ho avuto errori!');
        queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
        queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      }
    },
  })

  const rankingUpdateQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.tournaments().setRanking(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p.players),
      })},
    onSuccess: () => {
      // Invalidate and refetch
      message.success('Ranking successfully updated!');
      // window.location.reload(false)
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`tournament${id}`] })
      // window.location.reload(false)
    },
  })

  if (!id) return (<div></div>);
  
  return <Tournament 
          id={id} 
          tournament={tournamentQuery} 
          participants={participantsQuery} 
          addPlayer={addPlayerQuery}
          updateRanking={rankingUpdateQuery}
          hasRights={hasRights}
          multipliers={multipliersQuery}
          lpiSeasons={lpiseasonsQuery}
          byes={byesQuery}
          />;
}

export default RoutedTournament;